import React, { FunctionComponent } from 'react';
import { SecondaryLinkWithBoldModel } from '../navigationItem/models/navigationItem.model';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import { isInternalUrl } from '../../../../utils';
import { Link as RouterLink } from 'react-router-dom';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import { TSitecoreContext } from '../../../../types/types';
import { googleClickNavEvent } from '../../../../utils/analytics';

const SecondaryLinkWithBold: FunctionComponent<{
  model: SecondaryLinkWithBoldModel;
  onClick?: () => void;
  sitecoreContext: TSitecoreContext;
  menuTitle?: string;
}> = ({ model, onClick, sitecoreContext, menuTitle }) => {
  const wrapperClassName = 'navigation-link navigation-link--secondary-with-bold';
  const nonBoldTextClassName = 'navigation-link__non-bold-text';
  const dividerClassName = 'navigation-link__divider';
  const boldTextClassName = 'navigation-link__bold-text';
  const isEEActive = sitecoreContext?.pageEditing;
  const googleAnalyticsLabel = (model.linkText ?? '') + (model?.divider?.value ?? '') + (model?.boldText?.value ?? '');

  if (isEEActive) {
    return (
      <div className={wrapperClassName}>
        <CustomExternalAnchor field={model.link} className={nonBoldTextClassName} />{' '}
        <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
        <Text field={model.boldText} className={boldTextClassName} tag="span" />
      </div>
    );
  } else {
    if (isInternalUrl(model.linkUrl)) {
      return (
        <RouterLink
          to={model.linkUrl}
          {...model.linkOtherProps}
          className={wrapperClassName}
          onClick={(): void => {
            onClick && onClick();
            googleClickNavEvent('Global Nav', menuTitle, googleAnalyticsLabel);
          }}
        >
          <span className={nonBoldTextClassName}>{model.linkText}</span>{' '}
          <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
          <Text field={model.boldText} className={boldTextClassName} tag="span" />
        </RouterLink>
      );
    } else {
      return (
        <CustomExternalAnchor
          field={model.link}
          className={wrapperClassName}
          onClick={(): void => {
            googleClickNavEvent('Global Nav', menuTitle, googleAnalyticsLabel);
          }}
        >
          <span className={nonBoldTextClassName}>{model.linkText}</span>{' '}
          <Text field={model.divider} className={dividerClassName} tag="span" />{' '}
          <Text field={model.boldText} className={boldTextClassName} tag="span" />
        </CustomExternalAnchor>
      );
    }
  }
};

export default withSitecoreContext()(SecondaryLinkWithBold);
